import React from 'react';
import { IIconProps } from '../interfaces';

const AleaFeature02Icon: React.FC<IIconProps> = ({
  color = '#2B4956',
  size = '35',
  active = false,
}) => (
  <svg
    width={size}
    height={(22 / 35) * parseInt(String(size))}
    viewBox="0 0 35 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Frame 61" opacity={active ? '1' : '0.5'}>
      <g id="Bedsores">
        <g id="active">
          <g id="Supine Position">
            <path
              d="M27.5934 11.1464C28.7248 9.76366 29.3927 7.92455 29.3927 5.96484C29.3927 4.35976 28.2208 3.06153 26.7737 3.06153L22.8754 3.06153C23.0074 3.56106 23.0749 4.088 23.0681 4.63193C23.0288 7.74688 20.5663 10.239 17.5678 10.1982C14.5694 10.1574 12.1705 7.59922 12.2097 4.48426C12.2159 3.99194 12.2827 3.51518 12.4025 3.06152L8.52722 3.06152C7.08014 3.06152 5.9082 4.35975 5.9082 5.96484C5.9082 7.91921 6.56701 9.75933 7.68718 11.1464H27.5934Z"
              fill={active ? color : '#C6C6C6'}
            />
            <path
              d="M13.9455 4.62972C13.9191 6.64949 15.535 8.30827 17.5548 8.33471C19.5745 8.36115 21.2333 6.74524 21.2597 4.72547C21.2862 2.70571 19.6703 1.04693 17.6505 1.02048C15.6307 0.994044 13.972 2.60996 13.9455 4.62972Z"
              fill={active ? color : '#C6C6C6'}
            />
          </g>
          <g id="Bed">
            <path
              d="M1.67188 20.7899L1.72962 14.3913C1.74887 12.8783 2.7691 11.6078 4.00878 11.6232H31.0776C32.3173 11.6386 33.3067 12.8783 33.2874 14.3913L33.2297 20.7899"
              stroke={active ? color : '#C6C6C6'}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M2.05664 15.3809L33.241 15.3809"
              stroke={active ? color : '#C6C6C6'}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default AleaFeature02Icon;
